// frontend/src/components/TenantGeneralInfoTab.jsx
//
// Company-identity fields (name, logo, phone, address). Controlled/presentational:
// all state and the save handler live in the parent (TenantInfoForm), passed in
// as props. Its Save button calls onSave, which PUTs the FULL tenant object
// (Option A) -- so saving here also persists the current invoice-tab values.
//
// Retest focus: tenant info save, logo upload.

import React from "react";

const TenantGeneralInfoTab = ({
  formData,
  states,
  onChange,
  onSave,
  displayLogoUrl,
  uploadingLogo,
  onLogoUpload,
}) => {
  return (
    <>
      {displayLogoUrl && (
        <div className="mb-4 text-center">
          <div className="border rounded p-3 d-inline-block">
            <img
              src={displayLogoUrl}
              alt="Tenant Logo"
              style={{
                maxHeight: "120px",
                maxWidth: "100%",
                objectFit: "contain",
              }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
          <div className="text-muted mt-2">Current Company Logo</div>
        </div>
      )}

      <form onSubmit={onSave}>
        <div className="mb-3">
          <label className="form-label">Company Name</label>
          <input
            className="form-control"
            name="tenant_name"
            value={formData.tenant_name}
            onChange={onChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Company Logo</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={onLogoUpload}
            disabled={uploadingLogo}
          />
          {uploadingLogo && (
            <div className="form-text">
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
              >
                <span className="visually-hidden">Uploading...</span>
              </span>
              Uploading logo...
            </div>
          )}
          <div className="form-text">
            Maximum file size: 5MB. Supported formats: JPEG, PNG, GIF, WebP
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Phone Number</label>
          <input
            className="form-control"
            name="phone_number"
            type="tel"
            value={formData.phone_number}
            onChange={onChange}
            placeholder="123-456-7890"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Address Line 1</label>
          <input
            className="form-control"
            name="address_line_1"
            value={formData.address_line_1}
            onChange={onChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Address Line 2</label>
          <input
            className="form-control"
            name="address_line_2"
            value={formData.address_line_2}
            onChange={onChange}
          />
        </div>

        <div className="row g-3 mb-3">
          <div className="col-md-5">
            <label className="form-label">City</label>
            <input
              className="form-control"
              name="city"
              value={formData.city}
              onChange={onChange}
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">State</label>
            <select
              className="form-select"
              name="state_id"
              value={formData.state_id}
              onChange={onChange}
            >
              <option value="">-- Select State --</option>
              {states.map((s) => (
                <option key={s.state_id} value={s.state_id}>
                  {s.state_code} - {s.state_name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label">Postal Code</label>
            <input
              className="form-control"
              name="postal_code"
              value={formData.postal_code}
              onChange={onChange}
              pattern="[0-9]{5}"
              maxLength="5"
            />
          </div>
        </div>

        <div className="d-grid gap-2 d-md-block mt-4">
          <button className="btn btn-primary" type="submit">
            <i className="bi bi-save me-2"></i>
            Save Tenant Information
          </button>
        </div>
      </form>
    </>
  );
};

export default TenantGeneralInfoTab;